// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .login_wrapper{
    max-width: 1440px;
} */
.login_card {
    /* background: #7fffd4; */
    margin: auto;
    /* display: flex;
      flex-direction: column;
      justify-content: center;
      alignItems: "center", */
    /* max-width: 600px; */
    max-width: 400px;
    height: 388px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 16px;
    border-radius: 10px;
    box-shadow: 0px 4px 24px 0px #2a2a2a1f;
  }
  
  .textarea {
    padding: 0px 0px 5px 0px;
    border: 0px 0px 1px 0px;
    gap: 2px;
    margin-top: 10px;
  }
  
  .welcome {
    /* font-family: Open Sans; */
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    color: #003399;
  }
  
  .otp {
    /* font-family: Open Sans; */
    font-size: 10px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #003399;
  }
  
  .otpbutton {
    width: 100%;
    background-color: #003399;
    color: #fff;
    height: 42px;
    padding: 10px, 22px, 10px, 22px;
    border-radius: 8px;
    gap: 8px;
  }
  
  .loginbtn {
    width: 100%;
    background-color: #003399;
    color: #fff;
    height: 42px;
    padding: 10px, 22px, 10px, 22px;
    border-radius: 8px;
    gap: 8px;
  }
  
  
  
  
  .phonenumber {
    width: 100%;
    height: 40px;
    padding: 0px, 12px, 0px, 12px;
    border-radius: 8px;
    border: 1px;
  }
  
  .label-phone .ant-form-item .ant-form-item-label>label {
    color: #003399;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }
  
  .enterOtp .ant-form-item {
    margin-bottom: 8px;
  }
  
  .label-phone .ant-form-item {
    margin-bottom: 8px;
  
  }
  
  .enterOtp .input-otp {
    justify-content: start;
    gap: 8px;
  }
  
  .enterOtp .ant-form-item .ant-form-item-label>label {
    color: #003399;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }
  
  .enterOtp .input-otp__field {
    width: 79px;
    height: 48px;
    padding: 0px, 12px, 0px, 12px;
    border-radius: 8px;
    border: 1px solid #D8D8D8;
    max-width: 100px;
  }
  
  .details {
    /* width: 226px; */
    height: 14px;
  }
  
  .otp-info {
    color: #003399;
    font-size: 10px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
  
  }
  
  
  @media only screen and (min-width: 599px) {
    .resend {
      color: #003399;
      font-size: 10px;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: 0em;
      text-align: left;
    } 
     
  .resend1 {
    display: none;
  }
  }
  
  
  
  @media only screen and (max-width: 600px) {
  
    .resend {
     display: none;
    } 
  
    .login_wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
    }
  
    .login_card {
      max-width: 300px;
      width: 100%;
      padding: 16px;
      box-sizing: border-box;
    }
  
    
  .resend1 {
    color: #003399;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0em;
    display: flex;
    justify-content: center;
  }
  
  }
  
  .savebuttons .ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {
    background: #003399;
    color: #fff;
  }
  
  .savebuttons .ant-btn-default:not(:disabled):not(.ant-btn-disabled):active {
    background: #003399;
    color: #fff;
  
  }`, "",{"version":3,"sources":["webpack://./src/pages/setPassword/setPassword.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;IACI,yBAAyB;IACzB,YAAY;IACZ;;;6BAGyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,QAAQ;EACV;;;;;EAKA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;;EAEpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;;EAElB;;;EAGA;IACE;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB;IAClB;;EAEF;IACE,aAAa;EACf;EACA;;;;EAIA;;IAEE;KACC,aAAa;IACd;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,WAAW;MACX,aAAa;MACb,sBAAsB;IACxB;;;EAGF;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;;EAEb","sourcesContent":["/* .login_wrapper{\n    max-width: 1440px;\n} */\n.login_card {\n    /* background: #7fffd4; */\n    margin: auto;\n    /* display: flex;\n      flex-direction: column;\n      justify-content: center;\n      alignItems: \"center\", */\n    /* max-width: 600px; */\n    max-width: 400px;\n    height: 388px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    padding: 16px;\n    border-radius: 10px;\n    box-shadow: 0px 4px 24px 0px #2a2a2a1f;\n  }\n  \n  .textarea {\n    padding: 0px 0px 5px 0px;\n    border: 0px 0px 1px 0px;\n    gap: 2px;\n    margin-top: 10px;\n  }\n  \n  .welcome {\n    /* font-family: Open Sans; */\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #003399;\n  }\n  \n  .otp {\n    /* font-family: Open Sans; */\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #003399;\n  }\n  \n  .otpbutton {\n    width: 100%;\n    background-color: #003399;\n    color: #fff;\n    height: 42px;\n    padding: 10px, 22px, 10px, 22px;\n    border-radius: 8px;\n    gap: 8px;\n  }\n  \n  .loginbtn {\n    width: 100%;\n    background-color: #003399;\n    color: #fff;\n    height: 42px;\n    padding: 10px, 22px, 10px, 22px;\n    border-radius: 8px;\n    gap: 8px;\n  }\n  \n  \n  \n  \n  .phonenumber {\n    width: 100%;\n    height: 40px;\n    padding: 0px, 12px, 0px, 12px;\n    border-radius: 8px;\n    border: 1px;\n  }\n  \n  .label-phone .ant-form-item .ant-form-item-label>label {\n    color: #003399;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n  }\n  \n  .enterOtp .ant-form-item {\n    margin-bottom: 8px;\n  }\n  \n  .label-phone .ant-form-item {\n    margin-bottom: 8px;\n  \n  }\n  \n  .enterOtp .input-otp {\n    justify-content: start;\n    gap: 8px;\n  }\n  \n  .enterOtp .ant-form-item .ant-form-item-label>label {\n    color: #003399;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n  }\n  \n  .enterOtp .input-otp__field {\n    width: 79px;\n    height: 48px;\n    padding: 0px, 12px, 0px, 12px;\n    border-radius: 8px;\n    border: 1px solid #D8D8D8;\n    max-width: 100px;\n  }\n  \n  .details {\n    /* width: 226px; */\n    height: 14px;\n  }\n  \n  .otp-info {\n    color: #003399;\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n  \n  }\n  \n  \n  @media only screen and (min-width: 599px) {\n    .resend {\n      color: #003399;\n      font-size: 10px;\n      font-weight: 600;\n      line-height: 14px;\n      letter-spacing: 0em;\n      text-align: left;\n    } \n     \n  .resend1 {\n    display: none;\n  }\n  }\n  \n  \n  \n  @media only screen and (max-width: 600px) {\n  \n    .resend {\n     display: none;\n    } \n  \n    .login_wrapper {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 100vh;\n    }\n  \n    .login_card {\n      max-width: 300px;\n      width: 100%;\n      padding: 16px;\n      box-sizing: border-box;\n    }\n  \n    \n  .resend1 {\n    color: #003399;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 14px;\n    letter-spacing: 0em;\n    display: flex;\n    justify-content: center;\n  }\n  \n  }\n  \n  .savebuttons .ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {\n    background: #003399;\n    color: #fff;\n  }\n  \n  .savebuttons .ant-btn-default:not(:disabled):not(.ant-btn-disabled):active {\n    background: #003399;\n    color: #fff;\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
